/**
 * Campo di testo memoizzato con debounce locale
 * @module flyers/components/fields/MemoizedTextField
 */

import React from "react";
import { Input } from "antd";
import FloatingField from "@shared/components/FloatingField.jsx";
import { normalizePrice } from "../../utils/normalizers.js";

/**
 * Campo di testo ottimizzato con stato locale e propagazione onBlur
 */
const MemoizedTextField = React.memo(({ fieldKey, label, value, onChange, disabled, isPriceField }) => {
    const [localValue, setLocalValue] = React.useState(value || "");

    React.useEffect(() => {
        setLocalValue(value || "");
    }, [value]);

    const handleChange = React.useCallback((event) => {
        const newValue = event.target.value;
        setLocalValue(newValue);
    }, []);

    const handleBlur = React.useCallback((event) => {
        const finalValue = isPriceField ? normalizePrice(event.target.value) : event.target.value;
        if (finalValue !== value) {
            onChange(fieldKey, finalValue);
        }
    }, [fieldKey, onChange, value, isPriceField]);

    return (
        <FloatingField label={label}>
            <Input
                placeholder={label}
                value={localValue}
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={disabled}
            />
        </FloatingField>
    );
}, (prevProps, nextProps) => {
    return (
        prevProps.value === nextProps.value &&
        prevProps.disabled === nextProps.disabled &&
        prevProps.fieldKey === nextProps.fieldKey
    );
});

MemoizedTextField.displayName = "MemoizedTextField";

export default MemoizedTextField;
